import * as React from "react";
import {Field, Form} from "react-final-form";
import {Button, Col, Row} from "react-bootstrap";
import {rechazarDocumentos,reportarDocumentosComercial} from "../modulos/documentosActions";
import ModalConfirmacion from "../../general/componentes/ModalConfirmacion";
import {connect} from "react-redux";
import {MotivoRechazo} from "../modelo/Documento";

class ModalRechazo extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: props.show
        };
    }

    render() {
        return (
            <ModalConfirmacion titulo={this.props.canalComercial ? "Inconsistencia" : "Confirmar Rechazo"} show={this.props.show}
                               onCancelar={this.props.onCancelar}>
                Por favor seleccione el o los motivos de {this.props.canalComercial ? "inconsistencia" : "rechazo"}.
                <Form
                    onSubmit={this.rechazo}
                    validate={this.validate}
                    render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                        <form onSubmit={handleSubmit}>
                            <div className={"panel panel-primary"}>
                                <div className={"panel-heading"}>
                                    <h3 className={"panel-title"}>{this.props.canalComercial ? "Motivo Inconsistencia" : "Motivos Rechazo"}</h3>
                                </div>
                                <div className={"panel-body"}>
                                    <div className={"scroll"}>
                                    {this.props.motivosRechazo.map(motivo => {
                                        return (
                                            <Row key={motivo.codigo}>
                                                <Col sm={6}>
                                                    <label>
                                                        <Field
                                                            name="motivosRechazo"
                                                            component="input"
                                                            type="checkbox"
                                                            value={`${motivo.codigo}`}
                                                        />{" "}
                                                        {motivo.descripcion}
                                                    </label>
                                                </Col>
                                                <Col sm={6}>
                                                    <Field 
                                                        name={`observacion-${motivo.codigo}-`} 
                                                        component="textarea"
                                                        placeholder="Observación"
                                                        maxLength="300"
                                                    />
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                    </div>
                                    <div>
                                    <Row className="form-group pull-right">
                                        <Col sm={5}>
                                            <Button type="button" className="btns btn-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                Limpiar
                                            </Button>
                                        </Col>
                                        <Col sm={6}>
                                            <Button type="submit" className="btns btns-primary"
                                                    disabled={submitting || invalid}>
                                                {this.props.canalComercial ? "Enviar" : "Rechazar"}
                                            </Button>
                                        </Col>
                                    </Row>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                />
            </ModalConfirmacion>
        );
    }

    rechazo = (values) => {
        const {motivosRechazo, canalComercial} = this.props;

        const codigosRechazo: Array<MotivoRechazo> = values.motivosRechazo.map(codigo => {
            return {
                codigo: codigo,
                descripcion: motivosRechazo.find((mr => mr.codigo === codigo)).descripcion,
                observacion: values[`observacion-${codigo}-`]
            };
        });

        this.props.onCancelar();
        if(canalComercial) {
            this.props.dispatch(reportarDocumentosComercial(
                this.props.dni,
                this.props.dniRechaza,
                this.props.tipoCliente.id,
                codigosRechazo
            ));
        } else {
            this.props.dispatch(rechazarDocumentos(
                this.props.dni,
                this.props.dniRechaza,
                this.props.tipoCliente.id,
                codigosRechazo
            ));
        }
    };

    validate = values => {

        const errors = {motivosRechazo: undefined};

        if (!values.motivosRechazo || values.motivosRechazo.length === 0) {
            errors.motivosRechazo = "Por favor seleccione un motivo de rechazo";
        } else {
            if(this.props.canalComercial) {
                const motivoRechazoArrayErrors = [];
                values.motivosRechazo.map((motivoRechazoCodigo, motivoRechazoIndex) => { 
                    if (!values[`observacion-${motivoRechazoCodigo}-`]) {
                        motivoRechazoArrayErrors[motivoRechazoIndex] = true;
                    }
                });
                if (motivoRechazoArrayErrors.length) {
                    errors.motivosRechazo = "Cada motivo de inconsistencia marcado debe ingresar la observación";
                }
            }
        }
        return errors;
    }
}

export default connect((store: any, props: any) => {
    return {
        ...props
    };
})(ModalRechazo);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/ModalRechazo.tsx